// WebAuthN (passkey) support for the login page.
// login.js calls crushWA.assert() when the server answers a login with a
// "WEBAUTHN:" challenge_otp message (the key signs the challenge and the
// result is submitted as the OTP), and crushWA.offer() after a successful
// login to optionally register a new key (server controls eligibility via
// the webauthn_register_prompt / webauthn_register_prompt_remember
// WebInterface customization items).
(() => {
  const b64ToBuf = (s) => {
    s = s.replace(/-/g, "+").replace(/_/g, "/");
    const bin = atob(s + "=".repeat((4 - (s.length % 4)) % 4));
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out.buffer;
  };
  const bufToB64 = (buf) => {
    const bytes = new Uint8Array(buf);
    let bin = "";
    for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  };
  const cookie = (name) => {
    const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : "";
  };
  // posts command=... to the server, calls back with the url-decoded <response> text ("" on any error)
  const post = (params, cb) => {
    params.c2f = cookie("currentAuth");
    params.random = Math.random();
    const body = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch("/WebInterface/function/", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    })
      .then((r) => r.text())
      .then((text) => {
        const m = /<response>([\s\S]*?)<\/response>/.exec(text);
        cb(m ? decodeURIComponent(m[1].replace(/\+/g, "%20")) : "");
      })
      .catch(() => cb(""));
  };

  window.crushWA = {
    // answer a "WEBAUTHN:{options}" login challenge, cb gets the packed assertion to submit as the OTP
    assert: (msg, cb) => {
      let opts;
      try {
        opts = JSON.parse(msg.substring("WEBAUTHN:".length));
      } catch (e) {
        return;
      }
      opts.challenge = b64ToBuf(opts.challenge);
      (opts.allowCredentials || []).forEach((c) => (c.id = b64ToBuf(c.id)));
      navigator.credentials
        .get({ publicKey: opts })
        .then((cred) => {
          const r = cred.response;
          cb(
            [cred.rawId, r.clientDataJSON, r.authenticatorData, r.signature]
              .map(bufToB64)
              .join(",")
          );
        })
        .catch((e) => {
          console.error("WebAuthN assert:", e);
          alert("Passkey sign in failed or was canceled. " + e);
        });
    },
    // after a successful login, ask the server if we should offer to register a key. done() always continues the login.
    offer: (done) => {
      if (!window.PublicKeyCredential) return done();
      post({ command: "webauthnRegisterBegin" }, (resp) => {
        let o;
        try {
          o = JSON.parse(resp);
        } catch (e) {
          return done(); // not enabled for this user, already registered, error, etc.
        }
        const opts = o.publicKey;
        const declineKey = "webauthnDeclined_" + opts.user.name;
        if (o.remember && localStorage.getItem(declineKey) === "true")
          return done();
        if (
          !window.confirm(
            "Register a passkey (Touch ID, Windows Hello, security key) to verify future logins?"
          )
        ) {
          if (o.remember) localStorage.setItem(declineKey, "true");
          return done();
        }
        opts.challenge = b64ToBuf(opts.challenge);
        opts.user.id = b64ToBuf(opts.user.id);
        (opts.excludeCredentials || []).forEach((c) => (c.id = b64ToBuf(c.id)));
        navigator.credentials
          .create({ publicKey: opts })
          .then((cred) => {
            const r = cred.response;
            const pub = r.getPublicKey ? r.getPublicKey() : null;
            if (!pub) {
              alert("This browser cannot register a passkey here.");
              return done();
            }
            post(
              {
                command: "webauthnRegisterFinish",
                rawId: bufToB64(cred.rawId),
                clientDataJSON: bufToB64(r.clientDataJSON),
                authenticatorData: bufToB64(r.getAuthenticatorData()),
                publicKey: bufToB64(pub),
                publicKeyAlgorithm: r.getPublicKeyAlgorithm(),
              },
              (resp2) => {
                if (resp2 === "Success") localStorage.removeItem(declineKey);
                alert(
                  resp2 === "Success"
                    ? "Passkey registered. It will verify your future logins."
                    : "Passkey registration failed. " + resp2
                );
                done();
              }
            );
          })
          .catch((e) => {
            console.error("WebAuthN register:", e);
            if (e && e.name === "NotAllowedError") return done(); // user canceled or it timed out, continue login quietly
            alert(
              "Passkey registration could not start. " +
                (e && e.message ? e.message : e) +
                "\n\nWebAuthN requires HTTPS (or localhost) and uses the site's hostname as the key id, so it will not work over an IP address or plain HTTP."
            );
            done();
          });
      });
    },
  };
})();
